import { render, staticRenderFns } from "./OpinionTypeIcon.vue?vue&type=template&id=11892472&scoped=true&"
import script from "./OpinionTypeIcon.vue?vue&type=script&lang=js&"
export * from "./OpinionTypeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11892472",
  null
  
)

export default component.exports